import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { createScopedStorage } from "./workspaceStore";
import { getDrawingColorKey } from "../workspace/constants";

// Store for managing drawing colors for interactive objects
export const useDrawingColorStore = create(
  persist(
    (set, get) => ({
      // Current selected drawing color
      currentColor: "#FF6B35", // Default orange color

      // Set the current drawing color
      setCurrentColor: (color) => {
        set({ currentColor: color });
      },

      // Get the current drawing color
      getCurrentColor: () => {
        return get().currentColor;
      },
    }),
    {
      name: "drawing-color-storage", // Used as fallback name, actual key is dynamic (user-scoped)
      storage: createJSONStorage(() => createScopedStorage(getDrawingColorKey)),
      version: 1,
    },
  ),
);

// Listen for workspace context changes and rehydrate the store
if (typeof window !== "undefined") {
  window.addEventListener("workspace-context-changed", () => {
    console.log(
      "[DrawingColorStore] Rehydrating after workspace context change",
    );
    useDrawingColorStore.persist.rehydrate();
  });
}
